export function formatNumber(number) {
    return (number || 0).toLocaleString('en-AU', { minimumFractionDigits: 2, style: 'currency', currency: 'AUD', currencySign: 'accounting' });
}
export function getRandomInt(max = Number.MAX_SAFE_INTEGER) {
    return Math.floor(Math.random() * max);
}
